import React from "react";
import { FaPlus } from "react-icons/fa";
import { Message } from "@messageformat/react";
import styles from "./Cards.module.scss";

const Card = ({ title, description, youSave, image }) => {
  return (
    <div className={styles.card}>
      {image && (
        <div className={styles.cardImageBackground}>
          <img src={image} alt={title} />
        </div>
      )}

      <h3>{title}</h3>
      <div className={styles.description}>
        {description.split("\n").map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>

      <div className={styles.benefitsContainer}>
        <h4 className={styles.benefitsHeader}>
          <FaPlus className={styles.plusIcon} />
          <Message id="landingPage.cards.whatYouGain" />
        </h4>
        <div className={styles.badgesWrapper}>
          {youSave.map((item, index) => (
            <div key={index} className={styles.benefitsBadge}>
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card;
